import { render, staticRenderFns } from "./PixelIcon.vue?vue&type=template&id=eda460ac"
import script from "./PixelIcon.vue?vue&type=script&lang=js"
export * from "./PixelIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports